import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { AutomatedDetails } from './automated-details';
import { DeviceMode, ThemeMode } from '../../components/preview-controls';
import { useDeliveryChannel } from '../../campaign-builder/hooks';
import { useMetrics } from './use-metrics';
export var AutomatedDetailsContainer = function () {
    var _a = useState(false), showMore = _a[0], setShowMore = _a[1];
    var _b = useState(ThemeMode.dark), themeMode = _b[0], setThemeMode = _b[1];
    var _c = useState(DeviceMode.web), deviceMode = _c[0], setDeviceMode = _c[1];
    var metrics = useMetrics().metrics;
    // TODO: This will probably come from the campaign directly, replace with real data later
    var _d = useDeliveryChannel(), availableDeliveryChannelsOptions = _d.availableDeliveryChannelsOptions, selectedDeliveryChannel = _d.selectedDeliveryChannel, setSelectedDeliveryChannel = _d.setSelectedDeliveryChannel;
    return (_jsx(AutomatedDetails, { metrics: metrics, showMore: showMore, themeMode: themeMode, deviceMode: deviceMode, onShowMore: setShowMore, onThemeModeChange: setThemeMode, onDeviceModeChange: setDeviceMode, availableDeliveryChannelsOptions: availableDeliveryChannelsOptions, selectedDeliveryChannel: selectedDeliveryChannel, onSelectDeliveryChannel: setSelectedDeliveryChannel }));
};
